import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Quantity } from 'chronos-core-client';
import { knownUnits } from '../../models/knownUnits.model';
import { FormatUnitIdPipe } from '../format-unit-id/format-unit-id.pipe';

@Pipe({
  name: 'formatQuantity'
})
export class FormatQuantityPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe, private formatUnitIdPipe: FormatUnitIdPipe) {}

  public transform(quantity?: Quantity, showUnit: boolean = true, decimalPlaces?: number, showZero: boolean = true): string {
    const value = quantity?.value;
    const unitId = quantity?.unitId;

    if (typeof value !== 'number') {
      return '‒';
    }

    // Handle the empty instance case
    if (value === 0 && !unitId) {
      return '‒';
    }

    // Handle the zero value case
    if (value === 0 && !showZero) {
      return '‒';
    }

    const unitStartsWith = (unitName: string) => unitId?.startsWith(unitName);
    const hasWholeUnits = () => unitId === undefined || unitId === null || knownUnits.WholeUnits.some((unit) => unitStartsWith(unit));

    if (!decimalPlaces && !hasWholeUnits()) {
      decimalPlaces = 2;
    }

    const formattedNumber = this.formatNumber(value, decimalPlaces);
    const formattedUnitId = this.formatUnitIdPipe.transform(unitId);

    if (unitId && showUnit) {
      return `${formattedNumber} ${formattedUnitId}`;
    } else {
      return formattedNumber;
    }
  }

  private formatNumber(value: number, decimalPlaces?: number): string {
    const digits = decimalPlaces ?? 0;
    return this.decimalPipe.transform(value, `1.${digits}-${digits}`);
  }
}
